export function protectAdminRoleLiterals(content: string): {
  content: string
  restore: (value: string) => string
} {
  const protectedValues = [
    'UserRole.ADMIN',
    "'admin'",
    '"admin"',
    '`admin`',
    '>Admin</SelectItem>',
    'Manage admin users and roles'
  ]

  const replacements: Array<[string, string]> = []
  let protectedContent = content

  for (const [index, value] of protectedValues.entries()) {
    if (!protectedContent.includes(value)) {
      continue
    }

    const token = `__BETTERSTART_NAMESPACE_PROTECTED_${index}__`
    protectedContent = protectedContent.replaceAll(value, token)
    replacements.push([token, value])
  }

  return {
    content: protectedContent,
    restore(value: string): string {
      let restored = value
      for (const [token, original] of replacements) {
        restored = restored.replaceAll(token, original)
      }
      return restored
    }
  }
}
